import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManageCorporateService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getCorporateEmployees(loginID: number, userType: string, role: string): Observable<any> {
    const url = `${this.apiUrl}/user/corporate-employees?loginID=${loginID}&log_UserType=${userType}&role=${role}`;
    return this.http.get<any>(url);
  }
}
